export enum LocaleEnum {
  ru = 'ru',
  en = 'en',
  fr = 'fr',
}
